export default "__VITE_ASSET__Cn4BDWVj__";